// Standardized coupon image sizes across the application
export const COUPON_IMAGE_SIZES = {
    // Main display sizes for user-facing pages
    LARGE: {
        width: '100%',
        maxWidth: '400px',
        height: 'auto',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    },
    
    // Medium size for cards and detailed views
    MEDIUM: {
        width: '100%',
        maxWidth: '300px',
        height: 'auto',
        borderRadius: '8px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
    },
    
    // Small size for admin tables and lists
    SMALL: {
        width: 80,
        height: 30,
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'grey.300',
        transition: 'transform 0.3s ease',
        transformOrigin: 'left center',
        '&:hover': {
            transform: 'scale(3)',
            zIndex: 10,
            boxShadow: 3,
        },
        cursor: 'pointer',
    },
    
    // Hover/overlay size for previews
    HOVER: {
        maxWidth: 350,
        maxHeight: 350,
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
    },
    
    // Container sizes for responsive layouts
    CONTAINER: {
        LARGE: {
            maxWidth: { xs: "90%", sm: "400px" },
            width: "100%"
        },
        MEDIUM: {
            maxWidth: { xs: "90%", sm: "300px" },
            width: "100%"
        },
        SMALL: {
            width: 100,
            padding: "8px 16px"
        }
    }
};

// Helper function to get image styles based on context
export const getCouponImageStyles = (size = 'LARGE') => {
    return COUPON_IMAGE_SIZES[size];
};

// Helper function to get container styles based on context
export const getCouponContainerStyles = (size = 'LARGE') => {
    return COUPON_IMAGE_SIZES.CONTAINER[size];
};
